import { InjectionToken } from '@angular/core';

export enum AppsEnum {
    IB = "IB",
    TRADER = "TRADER",
    SUPPORTER = "SUPPORTER",
    CORPORATE = "CORPORATE"
}
export const APP_TOKEN = new InjectionToken<AppsEnum>('APP');
export const AUTH_SCOPE_TOKEN = new InjectionToken<string>('AUTH_SCOPE');
